<template>
	<div class="small-12 medium-2 columns text-center horse-selector">
		<div class="title-selections">
			<h4 class="sans-serif uppercase bold">{{ title }}</h4>
			<div class="selections hide-for-medium" :class="{ 'inactive': selectedHorses.length <= 0 }">{{ selectionsText }}</div>
		</div>
		<a href="#" class="tiny button hide-for-medium" @click.prevent="toggleEditPicks">Edit Picks</a>
		<ul class="no-bullet show-for-medium">
			<li v-for="cloth in cloths">
				<cloth-checkbox :selections="selectedHorses" :cloth="cloth + 1"></cloth-checkbox>
			</li>
		</ul>
		<div class="edit-picks mobile-overlay" :class="{ 'visible': showEditPicks }" data-scroll-overlay>
			<a class="close icon-button" href="#" @click.prevent="toggleEditPicks">
				<i class="fas fa-check"></i>
			</a>
			<div class="selectors-container">
				<h2 class="section-heading noborder"><em>Edit Your</em> Picks</h2>
				<div class="separator"></div>
				<div class="row collapse">
					<div class="small-12 columns text-center">
						<h4 class="bold uppercase sans-serif">{{ title }}</h4>
					</div>
				</div>
				<div class="row collapse">
					<div class="small-6 columns checkbox-outer nostyle" v-for="cloth in 24">
						<cloth-checkbox :selections="selectedHorses" :cloth="cloth + 1"></cloth-checkbox>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import ClothCheckbox from './ClothCheckbox.vue'
	import _ from 'underscore'
	import Vue from 'vue'
	export default {
		components: { ClothCheckbox },
		props: [ 'title', 'key', 'cloths' ],
		data () {
			return {
				selectedHorses: [],
				fireWatcher: true,
				showEditPicks: false
			}
		},
		watch: {
			'selectedHorses': function () {
				if (!this.fireWatcher) {
					this.fireWatcher = true;
					return;
				}
				this.$dispatch('selection-changed', this.key, this.selectedHorses);
			}
		},
		ready () {
			window.jQuery(document).trigger('reSVG');
		},
		methods: {
			updateSelections: function (selections, fireWatcher) {
				this.fireWatcher = fireWatcher;
				this.selectedHorses = selections;
			},
			toggleEditPicks () {
				this.showEditPicks = !this.showEditPicks;
				Vue.nextTick(function () {
					window.jQuery(document).trigger('scroll-overlay');
				});
			}
		},
		computed: {
			selectionsText () {
				if (Array.isArray(this.selectedHorses) &&
					this.selectedHorses.length > 0) {

					var sections = [];
					var runStart = false;
					var self = this;

					this.selectedHorses.sort(function (a, b) {
						var ai = parseInt(a, 10);
						var bi = parseInt(b, 10);
						if (ai < bi) return -1;
						else if (ai > bi) return 1;
						else return 0;
					});

					_.each(this.selectedHorses, function (selection, index) {

						// If we're different than the last selection...
						if (index > 0 && selection != self.selectedHorses[index - 1] + 1) {

							// If we're inside a run, close it.
							if (runStart !== false) {
								sections.push(runStart.toString() + '-' + self.selectedHorses[index - 1]);
								runStart = false;
							} else {
								sections.push(self.selectedHorses[index - 1]);
							}

						} else if (index > 0 && selection == self.selectedHorses[index - 1] + 1 && runStart === false) {

							// If we're the same as the previous selection,
							// start a new run.
							runStart = self.selectedHorses[index - 1];

						}

					});

					// Add the last item.
					if (runStart !== false) {
						sections.push(runStart.toString() + '-' + _.last(this.selectedHorses).toString());
					} else {
						sections.push(_.last(this.selectedHorses).toString());
					}

					return sections.join(', ');

				} else {
					return 'Pick some horses.';
				}
			}
		}
	}
</script>



/** WEBPACK FOOTER **
 ** HorseSelector.vue?222c1100
 **/